import { BASE_URL_BACKEND } from '@/constants';
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { supabase } from './supabase';
import PATH_PAGE from '@/router/path';
import { useAppState } from '@/store/app-state';
import { useServerlessStore } from '@/store/serverless';


const axiosInstance = axios.create({
  baseURL: BASE_URL_BACKEND,
});

axiosInstance.interceptors.request.use(
  async function (config) {
    const token = useServerlessStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    console.error('RequestInterceptor::', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
